<script lang="ts">
    import TemplateSettingsGeneral from './TemplateSettingsGeneral.svelte';
    import { _ } from 'svelte-i18n';
    import { customerSettings } from '../../../stores/api';
    import SettingsRowNumber from './SettingsRowNumber.svelte';
    import { z } from 'zod';
    import SelectHour from '../../shared/SelectHour.svelte';
    import SettingsRow from './SettingsRow.svelte';
    import SettingsRowLabel from './SettingsRowLabel.svelte';
    import SettingsRowValue from './SettingsRowValue.svelte';
    import Select from '../../shared/Select.svelte';
    import {
        routeTypes,
        RouteTypeSchema,
        vehicleEmissionClasses,
        vehicleMaxWeightTons,
        vehicleTypes,
    } from './settings';
    import CalculationPeriodManager from './CalculationPeriod/CalculationPeriodManager.svelte';
    import { debug } from '../../../stores/store';
    import { canWrite, writeDisabledTooltip } from '../../shared/Permissions/writeAccess';

    export let updateCustomer: () => void;

    let error: string = '';

    /**
     * Sekcja zostaje widoczna dla konta read-only - ukrycie odebraloby informacje o konfiguracji,
     * a nie tylko prawo zapisu (US-023). Wylaczamy wiec same kontrolki.
     */
    $: writeBlocked = !$canWrite;

    function validator(data: unknown) {
        return z.coerce.number().int().min(0).max(60).safeParse(data);
    }

    // export const RouteTypeSchema = z.union([
    //     z.literal('shortest'),
    //     z.literal('fastest'),
    //     z.literal('balanced'),
    // ]);
    // export type RouteTypeType = z.infer<typeof RouteTypeSchema>;

    function getRouteTypeItems() {
        return routeTypes.map((id: string) => {
            return { id, label: $_(id) };
        });
    }

    function getVehicleTypeItems() {
        return vehicleTypes.map((id: string) => {
            return { id, label: $_(id) };
        });
    }

    function getVehicleMaxWeightTonsItems() {
        return vehicleMaxWeightTons.map((i: number) => {
            return { id: i.toString(), label: i.toString() };
        });
    }

    function getVehicleEmissionClassItems() {
        return vehicleEmissionClasses.map((id: string) => {
            return { id, label: $_(id) };
        });
    }
</script>

<TemplateSettingsGeneral>
    <div slot="label">{$_('Calculations')}</div>
    <div slot="content">
        <!-- tooltip na kontenerze, bo wylaczone kontrolki nie lapia hovera (wzorzec z US-022) -->
        <div
            class="settings-group"
            class:error={error !== ''}
            title={writeBlocked ? $_(writeDisabledTooltip) : ''}
        >
            {#if $debug}
                <SettingsRow>
                    <SettingsRowLabel>
                        {$_('Route type')}
                    </SettingsRowLabel>
                    <SettingsRowValue>
                        <Select
                            bind:selected={$customerSettings.calculations.route_type}
                            items={getRouteTypeItems()}
                            disabled={writeBlocked}
                            onChange={() => {
                                updateCustomer();
                                return true;
                            }}
                        />
                    </SettingsRowValue>
                </SettingsRow>
                <SettingsRow>
                    <SettingsRowLabel>
                        {$_('Vehicle category')}
                    </SettingsRowLabel>
                    <SettingsRowValue>
                        <Select
                            width="90%"
                            bind:selected={$customerSettings.calculations.vehicle_type}
                            items={getVehicleTypeItems()}
                            disabled={writeBlocked}
                            onChange={() => {
                                updateCustomer();
                                return true;
                            }}
                        />
                    </SettingsRowValue>
                </SettingsRow>
                <SettingsRow>
                    <SettingsRowLabel>
                        {$_('Vehicle max weight')} [t]
                    </SettingsRowLabel>
                    <SettingsRowValue>
                        <Select
                            selected={$customerSettings.calculations.vehicle_max_weight_tons.toString()}
                            items={getVehicleMaxWeightTonsItems()}
                            disabled={writeBlocked}
                            onChange={selected => {
                                $customerSettings.calculations.vehicle_max_weight_tons =
                                    parseInt(selected);
                                updateCustomer();
                                return true;
                            }}
                        />
                    </SettingsRowValue>
                </SettingsRow>
                <SettingsRow>
                    <SettingsRowLabel>
                        {$_('Vehicle emission class')}
                    </SettingsRowLabel>
                    <SettingsRowValue>
                        <Select
                            bind:selected={$customerSettings.calculations.vehicle_emission_class}
                            items={getVehicleEmissionClassItems()}
                            disabled={writeBlocked}
                            onChange={() => {
                                updateCustomer();
                                return true;
                            }}
                        />
                    </SettingsRowValue>
                </SettingsRow>
            {/if}
            <SettingsRow>
                <SettingsRowLabel>
                    {$_('Scheduled moment of calculation')}
                </SettingsRowLabel>
                <SettingsRowValue>
                    <CalculationPeriodManager
                        bind:period={$customerSettings.calculations.period}
                        {updateCustomer}
                        disabled={writeBlocked}
                    />
                </SettingsRowValue>
            </SettingsRow>
        </div>
    </div>
</TemplateSettingsGeneral>
